var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"top"},[_vm._t("top")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2),_c('div',{staticClass:"bottom"},[_vm._t("bottom")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }